import React, { useEffect, useState, useContext } from "react";
import { CusSwitch } from "../From/Switch";
import { CusRadio } from "../From/Radio";
import CheckIcon from "../From/CheckIcon";
import { Global } from "../../App";
import { saveTempOrder } from "../../Api/GetOrder";
import { FormattedMessage } from "react-intl";
import { cond } from "lodash";

function Tool_extraNeedLIst({
  data,
  qId,
  onOpenToggle,
  removeExtraSelected,
  removeAddOrderExtraSelected,
  isExtraCheck,
  setIsExtraCheck,
  setIsSentOrder,
  setIsNeedStaffCheckModel,
  isNeedStaffCheckModel,
  needStaffCheckID,
  setselectedExtra,
}) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedExtraOptionList, setSelectedExtraOptionList] = useState([]);

  const handleModalOpen = (extraOptionList) => {
    setSelectedExtraOptionList(extraOptionList);

    setIsChecked(true);
  };
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  // 如果有被選亮燈

  const hasSelectedModeOnNew = (extraOptionList) => {
    const selected = extraOptionList.some(
      (extraOption) => extraOption.selectedMode != 0
    );

    let hasItemInGlobal;
    if (globalState.customer.orderInfo.extraDataList) {
      hasItemInGlobal = extraOptionList.some((extraOption) =>
        globalState.customer.orderInfo.extraDataList.some((globalExtraData) =>
          globalExtraData.selectedItemIDs.includes(extraOption.id)
        )
      );
    }
    if (globalState.ordermode == "addorder") {
      if (selected) {
        return true;
      }
    } else {
      if (hasItemInGlobal) {
        return true;
      }
    }
  };

  const isSelectedOption = (data) => {
    if (
      !globalState.selectedExtra ||
      !globalState.selectedExtra.selectedExtraA
    ) {
      return false;
    }

    return globalState.selectedExtra.selectedExtraA.some(
      (x) => x.qusetionId === qId
    );
  };

  const isSelectedOptionContent = (id) => {
    if (
      !globalState.selectedExtra ||
      !globalState.selectedExtra.selectedExtraA
    ) {
      return false;
    }

    return globalState.selectedExtra.selectedExtraA.some((x) => x.ansId === id);
  };

  useEffect(() => {
    //  給對單時 如果已經有選
    if (
      data.extraOptionList.some((extraOption) => extraOption.selectedMode === 1)
    ) {
      setIsChecked(true);
    }
  }, []);

  return (
    <div className={isExtraCheck == true && data.type == 1 ? "warning" : ""}>
      <div className="d-flex justify-content-between align-items-center pb-2 my-2 ">
        {data.selected == 1 ? (
          <span className="txtColorRed align-items-center">✻</span>
        ) : (
          <span className="p-1"></span>
        )}

        <h5 className="w-50 txtColorBrown ">{data.langName}</h5>
        <div className="w-50 d-flex justify-content-end align-items-center txtColorLightGreen">
          <div className="d-flex justify-content-end">
            {isSelectedOption(data) ? (
              <a
                onClick={() => {
                  hasSelectedModeOnNew(data.extraOptionList);
                  setIsSentOrder(false);
                  setIsNeedStaffCheckModel(true);
                  setselectedExtra();
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0704 2.10052L21.8988 4.92895L19.7775 7.05027L16.9491 4.22185L19.0704 2.10052ZM16.2423 4.92896L19.0707 7.75738L7.75698 19.0711L4.92855 16.2427L16.2423 4.92896ZM4.22273 16.9498L7.05116 19.7782L3.51562 20.4853L4.22273 16.9498Z"
                    // fill="#b9b9b9"
                    fill="#599e0b98"
                  />
                </svg>
              </a>
            ) : (
              ""
            )}
            <div className="d-flex flex-wrap">
              {data.extraOptionList
                .filter((item) => isSelectedOptionContent(item.id))
                .map((select, index) => (
                  <span key={index}>{select.langName}</span>
                ))}
            </div>
          </div>
          <label className="checkbox-label">
            {isSelectedOption(data) ? (
              ""
            ) : (
              <>
                <p
                  className="button-alter bgColorBrown"
                  onClick={() => {
                    setIsSentOrder(false);
                    setIsNeedStaffCheckModel(true);
                    setselectedExtra();
                  }}
                >
                  <FormattedMessage id={`page.extraNeed.pleaseSelect`} />
                </p>
              </>
            )}
          </label>
        </div>
      </div>
    </div>
  );
}

export default Tool_extraNeedLIst;
